import { Box, Theme, createStyles, makeStyles, useTheme } from "@mui/material";
import { Typography } from "@mui/material";
import { useState } from "react";

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         wrapper: { padding: theme.spacing(2) },
//     })
// );

const initaiTotalCounts = {
    totalCredit: "0",
    totalDebit: "0",
};

const SimpleDashboard = () => {
    const [count, setCount] = useState(0);
    const theme = useTheme();

    return (
        <Box
            style={{
                display: "flex",
                justifyContent: "center",
                padding: "1rem",
            }}
        >
            <Typography variant="h3" fontWeight={"bold"}>
                Welcome To BioMetric Attendance System
            </Typography>
        </Box>
    );
};

export default SimpleDashboard;
